<template>
  <div :class="$style.box">
    <div :class="$style.title">我的资料</div>
    <div :class="$style.avatar">
      <div :class="$style.content" @click="changeAvatar">
        <img :src="form.image" alt />
        <img :src="`${$cdnUrl}/camera.png`" alt />
      </div>
    </div>
    <div :class="$style.sex">
      <div :class="form.sex == 1 && $style.active">
        <img :src="`${$cdnUrl}/GG.png`" alt />
        <img :src="`${$cdnUrl}/choose.png`" alt :class="$style.choose" />
      </div>
      <div :class="form.sex == 2 && $style.active">
        <img :src="`${$cdnUrl}/MM.png`" alt />
        <img :src="`${$cdnUrl}/choose.png`" alt :class="$style.choose" />
      </div>
    </div>
    <div :class="$style.form">
      <van-field
        v-model="form.forum_name"
        placeholder="请输入昵称(最多8个字)"
        maxlength="8"
      ></van-field>
      <van-field
        v-model="form.motto"
        placeholder="写下您征服世界的座右铭(最多16个字)~"
        maxlength="16"
      ></van-field>
    </div>
    <p :class="$style.notice">
      <span>昵称</span>
      一经确认
      <span>三个月后才可修改</span>
      哦~
    </p>
    <img :class="$style.submit" :src="`${$cdnUrl}/entry.jpg`" alt @click="submit" />
  </div>
</template>

<script>
import { Field, Toast } from 'vant';
import UploadMixin from '@/mixins/uploadImage';
import { setAvatar, modifyUserInfo, getUserInfo } from '@/api/account';
import { reportData } from '@/api/report';
import { mapActions, mapState, mapMutations } from 'vuex';
import { getDevice } from '@/utils/getdevice.js';

export default {
  components: {
    vanField: Field,
  },
  mixins: [UploadMixin],
  data() {
    return {
      form: {
        sex: '',
        image: '',
        forum_name: '',
        motto: '',
        type: '', // 设备类型
      },
      submitFlag: false, // 防重复点击
    };
  },
  created() {
    this.initForm();
  },
  mounted() {
    reportData({
      type: 8,
    });
  },
  methods: {
    ...mapActions('account', {
      getUserInfo: 'getUserInfo',
    }),
    async setAvatar(src) {
      const r = await setAvatar({
        image: src,
      });
      this.getUserInfo();
    },
    // 初始化论坛头像昵称
    async initForm() {
      const r = await getUserInfo();
      let deviceType = 3; // 设备类型,默认是电脑
      if (getDevice().Mobile) {
        deviceType = 1;
      }
      if (getDevice().iPad) {
        deviceType = 2;
      }
      Object.assign(this.form, {
        sex: r.data.sex,
        image: r.data.images,
        forum_name: r.data.wechat_name,
        motto: '该用户很高冷，还没有个性签名~~',
        type: deviceType,
      });
    },
    // 修改头像
    changeAvatar() {
      this.uploadImage(1, false);
    },
    // 提交表单
    async submit() {
      if (this.submitFlag) return;
      this.submitFlag = true;
      let hasRegister = sessionStorage.getItem('hasRegister');
      if (hasRegister) {
        Toast('您已完成账号注册，请勿重复提交。');
        //######################### 可以考虑进入游戏圈 this.$router.replace(path) #################
        return;
      }
      if (!this.form.image) {
        Toast('请选择头像');
        return;
      }
      if (!this.form.forum_name) {
        Toast('请输入昵称');
        return;
      }
      if (!this.form.motto) {
        Toast('请输入个性签名');
        return;
      }
      try {
        const r = await modifyUserInfo(this.form);
        this.getUserInfo();
        sessionStorage.setItem('hasRegister', true);
        this.submitFlag = false;
        Toast('设置成功');
      } catch (error) {
      } finally {
        let redirectRoute = localStorage.getItem('redirectRoute');
        if (redirectRoute && redirectRoute[0] == '{') {
          redirectRoute = JSON.parse(redirectRoute);
          setTimeout(() => {
            this.$router.replace({
              name: redirectRoute.name || '/',
              query: redirectRoute.query || '',
            });
          }, 500);
        } else {
          this.$router.replace({ path: '/' });
        }
      }
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
.box {
  background: #ffffff;
  min-height: 100vh;
  .title {
    @include border-bottom-1px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-weight: 400;
  }
  .avatar {
    width: 100vw;
    height: 174px;
    background: {
      image: url('//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/bind_bg.png');
      repeat: no-repeat;
      size: cover;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      position: relative;
      > img:first-child {
        width: 90px;
        height: 90px;
        display: block;
        border-radius: 50%;
      }
      > img:last-child {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 26px;
        height: 26px;
      }
    }
  }
  .sex {
    display: flex;
    justify-content: center;
    img {
      width: 40px;
      height: 40px;
      margin: 0 30px;
    }
    .choose {
      display: none;
    }
    .active {
      position: relative;
      .choose {
        display: inline-block;
        position: absolute;
        bottom: 0;
        right: 0;
        background: url('//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/choose.png');
        width: 10px;
        height: 10px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
  }
  .form {
    margin-top: 24px;
    :global {
      .van-cell:not(:last-child)::after {
        border: none;
      }
      .van-field {
        margin: auto;
        margin-bottom: 8px;
        width: 250px;
        background: #f7f7f7;
        border-radius: 44px;
        font-size: 13px;
      }
      .van-field__body {
        > input {
          text-align: center;
          color: rgb(134, 133, 133);
        }
      }
    }
  }
  .notice {
    margin-top: 20px;
    margin-bottom: 30px;
    font-size: 13px;
    color: #9f9f9f;
    text-align: center;
    > span {
      color: #0d9bff;
    }
  }
  .submit {
    width: 130px;
    height: auto;
    display: block;
    margin: auto;
  }
}
</style>